import { useState } from "react";
import { toast } from "sonner";

// Hidden ₹1 PhonePe test page (unlinked from the site). Use to verify a real
// end-to-end payment without creating a ₹1 product in the shop.
// URL: /pay-test  (also /pay-test?amount=5 to override the amount)
export default function PayTest() {
  const [placing, setPlacing] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const raw = parseInt(params.get("amount") || "1", 10);
  const amount = Number.isFinite(raw) && raw >= 1 ? raw : 1;

  const onPay = async () => {
    setPlacing(true);
    try {
      const apiBase = process.env.REACT_APP_BACKEND_URL;
      const orderId = "INN_TEST_" + Date.now();

      // Register a placeholder order so the confirmation email fires post-payment
      await fetch(`${apiBase}/api/orders`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: orderId,
          items: [{ id: "test", slug: "test", name: `Innayaa Test Order (₹${amount})`, price: amount, quantity: 1, image: "" }],
          customer: {
            fullName: "Innayaa Test",
            email: "innayaaofficial@gmail.com",
            phone: "9999999999",
            address1: "Test Address",
            address2: "",
            city: "Mumbai",
            state: "Maharashtra",
            pincode: "400001",
            notes: "PhonePe live test — not a real order",
          },
          totals: { subtotal: amount, shipping: 0, codFee: 0, total: amount },
        }),
      });

      const r = await fetch(`${apiBase}/api/payments/phonepe/create`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          order_id: orderId,
          amount_inr: amount,
          customer_name: "Innayaa Test",
          customer_email: "innayaaofficial@gmail.com",
          customer_phone: "9999999999",
        }),
      });
      const data = await r.json();
      if (!r.ok || !data.redirectUrl) throw new Error(data.detail || "Could not start payment");
      window.location.assign(data.redirectUrl);
    } catch (e) {
      setPlacing(false);
      toast.error(e.message || "Payment could not be started");
    }
  };

  return (
    <div data-testid="pay-test-page" className="bg-[#FAF8F5]">
      <section className="max-w-[600px] mx-auto px-5 sm:px-6 md:px-10 py-16 md:py-24 text-center">
        <p className="overline">Internal · PhonePe test</p>
        <h1 className="mt-4 font-serif text-4xl sm:text-5xl tracking-tight text-[#2A2626] leading-tight">
          ₹{amount} live payment test
        </h1>
        <p className="mt-5 text-[15px] text-[#5C564F] max-w-md mx-auto leading-relaxed">
          Clicking below will redirect to PhonePe&rsquo;s hosted checkout for a real
          ₹{amount} charge to your UPI / card. This page is not linked anywhere on
          the site — use only for verification.
        </p>
        <button
          onClick={onPay}
          disabled={placing}
          data-testid="pay-test-button"
          className="mt-10 inline-block bg-[#2A2626] text-[#FAF8F5] px-10 py-4 text-[11px] uppercase tracking-[0.28em] hover:bg-[#3A3632] transition-colors disabled:opacity-60"
        >
          {placing ? "Redirecting to PhonePe…" : `Pay ₹${amount} via PhonePe`}
        </button>
        <p className="mt-6 text-[11px] uppercase tracking-[0.22em] text-[#5C564F]">
          After payment, you&rsquo;ll return to the payment-status page.
        </p>
      </section>
    </div>
  );
}
